module.exports = __webpack_public_path__ + "img/kaggle.09d3d36a.png";